import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Gallery from './Gallery';
import NextArrow from './NextArrow';
import PrevArrow from './PrevArrow';
import ImageCounter from './ImageCounter';

export default class GalleryContainer extends Component {
    static propTypes = {
        images: PropTypes.array.isRequired,
        onExitClick: PropTypes.func.isRequired,
        imageIndex: PropTypes.number.isRequired,
    };

    componentDidMount() {
        this.scrollY = window.scrollY;
        window.scroll(0, 0);
        document.documentElement.style.overflow = document.body.style.overflow =
            'hidden';
        document.documentElement.style.position = document.body.style.position =
            'relative';
        document.documentElement.style.height = document.body.style.height =
            '100%';
    }

    componentWillUnmount() {
        document.documentElement.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('position');
        document.documentElement.style.removeProperty('height');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('height');
        window.scrollTo(0, this.scrollY);
    }

    state = { slideIndex: this.props.imageIndex + 1 };

    sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        initialSlide: this.props.imageIndex,
        slidesToScroll: 1,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        lazyLoad: false,
        afterChange: this.onSlideChange.bind(this),
    };

    onSlideChange(index) {
        this.setState({
            slideIndex: index + 1,
        });
    }

    renderImageCounter() {
        const nOfSlides = this.props.images ? this.props.images.length : 0;

        return (
            <ImageCounter index={this.state.slideIndex} nOfSlides={nOfSlides} />
        );
    }

    render() {
        return (
            <div>
                <Gallery
                    currentImageCounter={this.renderImageCounter()}
                    images={this.props.images}
                    onExitClick={this.props.onExitClick}
                    settings={this.sliderSettings}
                    slideIndex={this.state.slideIndex - 1}
                />
            </div>
        );
    }
}
